import { Button,Divider } from '@material-ui/core';
import { FieldArray, Form, Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import FunctionNotificationStep from './FunctionNotificationStep';
import WorkflowStepsSelect from './WorkflowStepsSelect';

const WorkflowStepsSelectContainer = styled.div`
  padding-top : 10px;
  padding-bottom : 10px;
  padding-left: 20px;
  padding-right: 20px;
  width:100%;
  background-color:#ecf5fa;
  display:flex;
  align-items:center;
  justify-content:space-between;
  height: 68px !important;
`;

const ContainerFooter = styled.div`
    width:100%;
    display:flex;
    height:40px;
    justify-content:flex-end;
    padding-right:20px;    
    border-top-width:1px;
`;


const AddButtonHelperText = styled.div`
  font-weight:500;
  font-size:15px;
`;

const PaddingContainer = styled.div`
    padding:10px;

`;

const ButtonContainer = styled.div`
    padding:10px;

`;

const TextFieldLabel = styled.div`
font-family: Roboto;
font-size: 14px;
font-weight: 400;
`
function sortNotifications(notifications) {
  return notifications.sort((p1, p2) => {
    if (p1.name > p2.name) { return 1; }
    if (p1.name < p2.name) { return -1; }
    return 0;
  });
}

function getNotificationsForSelectedWorkflowStep(props) {
  let notificationsForSelectedWorkFlow = [];
  if (props.context) {
    notificationsForSelectedWorkFlow = props.initialValues.workflowSteps.filter(ws => ws.id === props.context.selectedWorkflowStep);
  }
    
  return notificationsForSelectedWorkFlow.length > 0 ? sortNotifications(notificationsForSelectedWorkFlow[0].notifications) : notificationsForSelectedWorkFlow;
}

const FunctionNotificationForm = (props) => (
  

  <div>
    <Formik
      initialValues={props.initialValues}
      onSubmit={values =>
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
        }, 500)
      }
      render={(formProps) => (
        <Form>
          <FieldArray
            name="workFlowNotificationSteps"
            render={arrayHelpers => (
              <>
                <WorkflowStepsSelectContainer>
                  <WorkflowStepsSelect/>
                </WorkflowStepsSelectContainer>
                <Divider/>
               
                {formProps.values.workflowSteps &&
                    <>
                 
                  {getNotificationsForSelectedWorkflowStep(props).map((notificationStep, index) => (
                    <FunctionNotificationStep formProps={formProps} selectedStepId={props.context.selectedWorkflowStep} index={index} />
                  ))}
                  <Divider/>
                  <PaddingContainer/>
                  <ContainerFooter>
                        <ButtonContainer>
                            <Button variant="outlined" color="primary" onClick={()=>{
                                props.context.setSelectedWorkflowStep('');
                                props.context.closeFunctionNotificationDialog();
                            }}>Cancel</Button>
                        </ButtonContainer>

                        <ButtonContainer>
                            <Button variant="contained" color="primary" onClick={()=>{
                               props.context.setSelectedWorkflowStep('');
                               props.context.updateFunctionNotifications(formProps.values, props.context.selectedWorkflowStep);
                               props.context.closeFunctionNotificationDialog();
                            }}>Save</Button>
                        </ButtonContainer>
                  </ContainerFooter>
                  </>
                }
                
              </>
            )}
          />
        </Form>
      )}
    />
  </div>
);


export default FunctionNotificationForm;